<template>
  <v-container class="no-margins">
    <v-card v-if="obj.validated == true" class="qrValidation px-4 mt-n10" flat>
      <v-card-title>
        <v-icon>$sl-check-circle</v-icon>
        <h1>{{ $t("company.qr-validation-title-valid") }}</h1>
      </v-card-title>
      <v-card-text>
        <h6 class="mb-8">{{ $t("company.qr-validation-text-valid") }}</h6>
        <p
          class=""
          v-if="
            obj.distanceEducationProviderCourse &&
            obj.distanceEducationProviderCourse.name
          "
        >
          {{ $t("company.qr-validation-text2-valid") }}
          <b>{{ obj.distanceEducationProviderCourse.name || "" }}</b>
        </p>
        <p
          class=""
          v-else-if="
            obj.educationProfessionOrientations &&
            obj.educationProfessionOrientations.length > 0
          "
        >
          {{ $t("company.qr-validation-text2-valid") }}
          <!-- <b>{{ obj.educationProfessionOrientations.name || "" }}</b> -->
          <b>{{
            obj.educationProfessionOrientations
              .map((o) => o.professionMachineOrientation.machine.name)
              .join(", ")
          }}</b>
        </p>
        <p
          class=""
          v-else-if="
            obj.educationDistanceEducationProviderCourses &&
            obj.educationDistanceEducationProviderCourses.length > 0
          "
        >
          {{ $t("company.qr-validation-text2-valid") }}
          <!-- <b>{{ obj.educationProfessionOrientations.name || "" }}</b> -->
          <b>{{
            obj.educationDistanceEducationProviderCourses
              .map((o) => o.distanceEducationProviderCourse.name)
              .join(", ")
          }}</b>
        </p>
        <p
          class=""
          v-else-if="obj.tradeCertificates.length > 0
          "
        >
          {{ $t("company.qr-validation-text2-valid") }}
          <!-- <b>{{ obj.educationProfessionOrientations.name || "" }}</b> -->
          <!-- <b>{{
            obj.tradeCertificates
              .map((o) => o.profession.name)
              .join(", ")
          }}</b> -->
          <b v-for="(item, index) in obj.tradeCertificates" :key="index">
            {{item.profession.name}}<span v-if="item.machineQualifications && item.machineQualifications.length>0">/{{item.machineQualifications
              .map((o) => o.machine.name)
              .join(", ")}}</span>
            <span v-if="index!=obj.tradeCertificates.length-1">,</span>
          </b>
        </p>
        <template v-if="obj && obj.education && obj.education.person">
          <p>
            {{ $t("company.qr-validation-name") }}
            <b
              >{{ obj.education.person.firstName || "" }}
              {{ obj.education.person.lastName || "" }}</b
            >
          </p>
          <p class>
            {{ $t("company.qr-validation-persno") }}
            <b>{{ obj.education.person.personalNumber | persno }}</b>
          </p>
        </template>
        <template v-else-if="obj && obj.person">
          <p>
            {{ $t("company.qr-validation-name") }}
            <b
              >{{ obj.person.firstName || "" }}
              {{ obj.person.lastName || "" }}</b
            >
          </p>
          <p class>
            {{ $t("company.qr-validation-persno") }}
            <b>{{ obj.person.personalNumber | persno }}</b>
          </p>
        </template>
        <template v-else-if="obj && obj.firstName">
          <p>
            {{ $t("company.qr-validation-name") }}
            <b>{{ obj.firstName || "" }} {{ obj.lastName || "" }}</b>
          </p>
          <p class>
            {{ $t("company.qr-validation-persno") }}
            <b>{{ obj.personalNumber | persno }}</b>
          </p>
        </template>
        <p class="mt-6" v-html="$t('company.qr-validation-text3-valid')"></p>
      </v-card-text>
    </v-card>
    <v-card
      v-else-if="obj.validated == false"
      class="qrValidation qrValidation__invalid px-4 mt-n10"
      flat
    >
      <v-card-title>
        <v-icon>$sl-stop</v-icon>
        <h1>{{ $t("company.qr-validation-title-invalid") }}</h1>
      </v-card-title>
      <v-card-text>
        <h6>{{ $t("company.qr-validation-text-invalid") }}</h6>
        <p class="mt-8">{{ $t("company.qr-validation-text2-invalid") }}</p>
        <p class="mt-6">
          <b>{{ $t("company.qr-validation-text3-invalid") }}</b>
        </p>
        <p class="mt-6" v-html="$t('company.qr-validation-text4-invalid')"></p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QrValidation",

  data: () => ({
    obj: {
      id: "",
      validated: null,
      machine: "",
      person: {
        firstName: "",
        lastName: "",
        personalNumber: "",
      },
    },
  }),

  components: {},
  created() {
    this.getValidate();
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser"]),
  },
  filters: {
    persno: function (value) {
      if (!value || value.length < 10) return "";

      return value.substring(0, 8) + "-" + value.substring(8, 12);
    },
  },
  methods: {
    getValidate() {
      if (this.$route.params.id) {
        API.getValidate(this.$route.params.id)
          .then((res) => {  console.log("res::", res.data)
            this.obj = res.data;
          })
          .catch((error) => {
            this.$events.fire("showError", this.$t("errors.save-failure"));
            console.log(error);
            //this.obj.validated = false;
          });
      }
    },
  },
};
</script>
